import { api_GET, api_POST, api_PUT } from './_api';

const email_api = {
    GetList: () => {
        const promise = new Promise((resolve, reject) => {
            api_GET(`Email/GetList`)
                .then(result => resolve(result))
                .catch(result => reject(result))
        });
        return promise;
    },
    GetItem: (id) => {
        const promise = new Promise((resolve, reject) => {
            api_GET(`Email/GetItem/${id}`)
                .then(result => resolve(result))
                .catch(result => reject(result))
        });
        return promise;
    },
    Post: (obj) => {
        const promise = new Promise((resolve, reject) => {
            api_POST(`Email`, obj)
                .then(result => resolve(result))
                .catch(result => reject(result))
        });
        return promise;
    },
    Put: (obj) => {
        const promise = new Promise((resolve, reject) => {
            api_PUT(`Email`, obj)
                .then(result => resolve(result))
                .catch(result => reject(result))
        });
        return promise;
    }
}

export default email_api;